import { connect } from 'react-redux';

// TODO: Fix ts-ignore HolderProfile
// @ts-ignore
import HolderProfile from '../components/holder_profile';

import actions from '../redux/actions';
import { selectRemainingBonusAmount } from 'redux/reducers/homeless';

// state is object that holds reducers from combineReducers and hence the state in them
function mapStateToProps(state: any) {
    const { catchUpItems, catchUpItemStatus } = state.catchUpItems;
    const {
        debitCardOptions,
        debitHistory,
        debitInfo,
        fullDebitHistory,
        isFetchingDebitCardOptions,
        isFetchingDebitHistory,
        isFetchingDebitInfo
    } = state.debitCard;
    const {
        deploymentOrgs,
        deploymentUsers,
        isFetchingDeploymentOrgs,
        isFetchingDeploymentUsers,
        isReferringMember,
        referMemberError,
        isReferringCareCoordinator,
        referCareCoordinatorError
    } = state.deployments;
    const { determinantRanks, isFetchingDeterminantRanks } =
        state.determinantRanks; // don't need anymore
    const { getApiErrorResponse } = state.error;
    const { isFetchingHomelessGoals } = state.goals;
    const {
        homelessGoalActions,
        isEditingGoalAction,
        isFetchingHomelessGoalActions,
        newHomelessGoalActions
    } = state.goalActions;
    const {
        assignedBonusAmount,
        historyFilters,
        homelessHistory,
        homelessInfo,
        homelessLifeStory,
        homelessLifeStorySuccess,
        isFetchingHomelessHistory,
        isFetchingHomelessInfo,
        isFetchingHomelessLifeStory,
        isSubmittingHomelessLifeStory,
        notFoundHomelessInfo,
        profileCompletionPercentage,
        profileItems,
        profileRemainingItems
    } = state.homeless;
    const { caseloads } = state.homelesses;
    const { intakeId } = state.intake;
    const { fullMemberPayments, memberPayments, isFetchingMemberPayments } =
        state.payments;
    const { redemptionList } = state.redemption;
    const { memberReferrals } = state.referrals;
    
    const { memberCareCoordinatorReferrals } = state.referrals;
    const {
        goalActionCompletePopupId,
        layoutTitles,
        showGoalActionCompletePopup
    } = state.samaritan; // don't use goalActionPopups, update layoutTitles
    const { homelessTouchpoints, isFetchingHomelessTouchpoints } =
        state.touchpoints;
    const {
        improvedStatus,
        improvedStatusCount,
        isFetchingSupplementalQuestionAnswers,
        isFetchingTouchpointAnswers,
        isFetchingTouchpointAnswersById,
        isSubmittingTouchpointAnswers,
        previousAnswers,
        supplementalQuestionAnswers,
        touchpointAnswers,
        touchpointAnswersById,
        updatedAnswerIds,
        updatedQuestionIds
    } = state.touchpointAnswers;
    const {
        isFetchingSupplementalQuestions,
        isFetchingTouchpointQuestions,
        isFetchingTouchpointQuestionIds,
        isFetchingTouchpointQuestionQOLs,
        supplementalQuestions,
        supplementalQuestionIds,
        touchpointQuestions,
        touchpointQuestionIds,
        touchpointQuestionQOLs
    } = state.touchpointQuestions;
    const { route } = state.unenrollment;
    const { maxBonusAmount, user, state: userState } = state.user;

    return {
        assignedBonusAmount,
        caseloads,
        catchUpItems,
        catchUpItemStatus,
        debitCardOptions,
        debitHistory,
        debitInfo,
        deploymentOrgs,
        deploymentUsers,
        determinantRanks,
        fullDebitHistory,
        fullMemberPayments,
        getApiErrorResponse,
        goalActionCompletePopupId,
        historyFilters,
        homelessGoalActions,
        homelessHistory,
        homelessInfo,
        homelessLifeStory,
        homelessLifeStorySuccess,
        homelessTouchpoints,
        improvedStatus,
        improvedStatusCount,
        intakeId,
        isEditingGoalAction,
        isFetchingDebitCardOptions,
        isFetchingDebitHistory,
        isFetchingDebitInfo,
        isFetchingDeploymentOrgs,
        isFetchingDeploymentUsers,
        isFetchingDeterminantRanks,
        isFetchingHomelessGoals,
        isFetchingHomelessGoalActions,
        isFetchingHomelessHistory,
        isFetchingHomelessInfo,
        isFetchingHomelessLifeStory,
        isFetchingHomelessTouchpoints,
        isFetchingMemberPayments,
        isFetchingSupplementalQuestions,
        isFetchingSupplementalQuestionAnswers,
        isFetchingTouchpointAnswers,
        isFetchingTouchpointAnswersById,
        isFetchingTouchpointQuestions,
        isFetchingTouchpointQuestionIds,
        isFetchingTouchpointQuestionQOLs,
        isReferringMember,
        isSubmittingHomelessLifeStory,
        isSubmittingTouchpointAnswers,
        layoutTitles,
        maxBonusAmount,
        memberPayments,
        memberReferrals,
        memberCareCoordinatorReferrals,
        newHomelessGoalActions,
        notFoundHomelessInfo,
        previousAnswers,
        profileCompletionPercentage,
        profileItems,
        profileRemainingItems,
        redemptionList,
        referMemberError,
        isReferringCareCoordinator,
        referCareCoordinatorError,
        remainingBonusAmount: selectRemainingBonusAmount(state),
        route,
        showGoalActionCompletePopup,
        supplementalQuestions,
        supplementalQuestionAnswers,
        supplementalQuestionIds,
        touchpointAnswers,
        touchpointAnswersById,
        touchpointQuestions,
        touchpointQuestionIds,
        touchpointQuestionQOLs,
        updatedAnswerIds,
        updatedQuestionIds,
        user,
        userState
    };
}

const mapDispatchToProps = {
    acceptReferral: actions.acceptReferral,
    assignDebitCard: actions.assignDebitCardRequest,
    createMemberCaseload: actions.createMemberCaseload,
    getCaseloads: actions.getCaseloads,
    getCatchUpItems: actions.fetchCatchUpItemsRequest,
    getDebitCardHistory: actions.getDebitCardHistory,
    getDebitCardInfo: actions.getDebitCardInfo,
    getDebitCardOptions: actions.fetchDebitCardOptionsRequest,
    getDeploymentOrgs: actions.fetchDeploymentOrgsRequest,
    getDeploymentUsers: actions.fetchDeploymentUsersRequest,
    getDeterminantRanks: actions.getDeterminantRanksRequest,
    getReferrals: actions.fetchMemberReferralsRequest,
    getMemberCareCoordinatorReferrals: actions.fetchMemberCareCoordinatorReferralsRequest,
    getHistoryFilters: actions.getHistoryFilters,
    getHomelessGoalActions: actions.getHomelessGoalActions,
    getHomelessInfo: actions.getHomelessInfo,
    getHomelessLifeStory: actions.getHomelessLifeStory,
    getMemberHistory: actions.getHomelessHistory,
    getMemberPayments: actions.getMemberPayments,
    getSupplementalQuestionAnswersRequest:
        actions.getSupplementalQuestionAnswersRequest,
    getSupplementalQuestionsRequest: actions.getSupplementalQuestionsRequest,
    getTouchpointQuestionsRequest: actions.getTouchpointQuestionsRequest,
    getTouchpointAnswersRequest2: actions.getTouchpointAnswersRequest2,
    getTouchpointAnswersByIdRequest: actions.getTouchpointAnswersByIdRequest,
    referMember: actions.referMemberRequest,
    referCareCoordinator: actions.referCareCoordinatorRequest,
    rejectReferral: actions.rejectReferral,
    removeMemberFromMyMembers: actions.removeMemberFromMyMembers,
    resetIntake: actions.resetIntake,
    saveMemberToMyMembers: actions.saveMemberToMyMembers,
    setGoalActionCompletePopupId: actions.setGoalActionCompletePopupId,
    setLayoutTitles: actions.setLayoutTitles,
    setProfileCompletedItems: actions.setProfileCompletedItems,
    toggleGoalActionCompletePopup: actions.setGoalActionCompletePopup,
    updateGoalActionMatchAmount: actions.updateGoalActionMatchAmount,
    updateGoalActionStatus: actions.updateGoalActionStatus,
    updateHomelessInfoField: actions.updateHomelessInfoField,
    updateHomelessLifeStory: actions.updateHomelessLifeStoryRequest,
    updateProfileCompletedItems: actions.updateProfileCompletedItems,
    updateTouchpointAnswers: actions.updateTouchpointAnswers
};

export default connect(mapStateToProps, mapDispatchToProps)(HolderProfile);
